import { Spinner } from '@chakra-ui/react'

const SpinnerLoading = ({
	size = 'sm',
	color = 'black',
}: {
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
	color?: string
}) => {
	return <Spinner size={size} color={color} />
}

export default SpinnerLoading
